import { render, staticRenderFns } from "./sidebar-payments.vue?vue&type=template&id=282d1c76&scoped=true&"
import script from "./sidebar-payments.vue?vue&type=script&lang=js&"
export * from "./sidebar-payments.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-payments.vue?vue&type=style&index=0&id=282d1c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d1c76",
  null
  
)

export default component.exports